import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { HOURS } from "@/data/site";
import SectionLabel from "./SectionLabel";

export default function Hours() {
  return (
    <section
      id="horaires"
      className="relative py-24 md:py-32 bg-[#EFEBE3]"
      data-testid="hours-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <SectionLabel
          eyebrow="Horaires"
          title={<>Quand nous rendre<br /><span className="italic text-[#8B5A2B]">visite</span></>}
          center
        />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="bg-[#F9F6F0] rounded-2xl p-8 md:p-12 border border-[#E6DFD3] shadow-[0_10px_60px_rgba(28,25,23,0.05)]"
        >
          <div className="flex items-center gap-3 mb-8 justify-center text-[#8B5A2B]">
            <Clock strokeWidth={1.2} className="w-5 h-5" />
            <span className="text-xs tracking-[0.4em] uppercase font-body">
              Sur rendez-vous
            </span>
          </div>
          <ul className="divide-y divide-[#E6DFD3]">
            {HOURS.map((h, i) => {
              const open = !h.time.toLowerCase().includes("fermé");
              return (
                <motion.li
                  key={h.day}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.05 }}
                  className="flex items-baseline justify-between py-4 md:py-5"
                  data-testid={`hours-${h.day.toLowerCase()}`}
                >
                  <span className="font-display text-xl md:text-2xl text-stone-900 font-normal">
                    {h.day}
                  </span>
                  <span
                    className={`font-body text-sm md:text-base tracking-wide ${
                      open ? "text-[#8B5A2B] font-medium" : "text-stone-400 italic font-light"
                    }`}
                  >
                    {h.time}
                  </span>
                </motion.li>
              );
            })}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
